import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';

interface PerformanceRecord {
  c3D: string;
  c3J: string;
  c3S: string;
  c26: number;
}

interface Props {
  records: PerformanceRecord[];
  colors: string[];
}

const C3DrilldownPieChart: React.FC<Props> = ({ records, colors }) => {
  const [level, setLevel] = useState<'c3D' | 'c3J' | 'c3S'>('c3D');
  const [parent, setParent] = useState<string | undefined>(undefined);

  let labels: string[] = [];
  let values: number[] = [];
  let title = '3차 대분류별 매출';

  if (level === 'c3D') {
    const map: Record<string, number> = {};
    records.forEach(rec => {
      if (rec.c3D) map[rec.c3D] = (map[rec.c3D] || 0) + rec.c26;
    });
    labels = Object.keys(map);
    values = Object.values(map);
    title = '3차 대분류별 매출';
  } else if (level === 'c3J' && parent) {
    const map: Record<string, number> = {};
    records.filter(rec => rec.c3D === parent).forEach(rec => {
      if (rec.c3J) map[rec.c3J] = (map[rec.c3J] || 0) + rec.c26;
    });
    labels = Object.keys(map);
    values = Object.values(map);
    title = `3차 중분류별 매출 - ${parent}`;
  } else if (level === 'c3S' && parent) {
    const map: Record<string, number> = {};
    records.filter(rec => rec.c3J === parent).forEach(rec => {
      if (rec.c3S) map[rec.c3S] = (map[rec.c3S] || 0) + rec.c26;
    });
    labels = Object.keys(map);
    values = Object.values(map);
    title = `3차 소분류별 매출 - ${parent}`;
  }

  const handlePieClick = (evt: any, elements: any[]) => {
    if (!elements || elements.length === 0) return;
    const idx = elements[0].index;
    if (level === 'c3D') {
      setLevel('c3J');
      setParent(labels[idx]);
    } else if (level === 'c3J') {
      setLevel('c3S');
      setParent(labels[idx]);
    }
  };

  const handleBack = () => {
    if (level === 'c3S' && parent) {
      const parentJ = records.find(rec => rec.c3S === parent)?.c3J;
      setLevel('c3J');
      setParent(parentJ);
    } else if (level === 'c3J') {
      setLevel('c3D');
      setParent(undefined);
    }
  };

  return (
    <div className="drilldown-box">
      <h2>
        {title}
        {level !== 'c3D' && (
          <button onClick={handleBack}>◀ 뒤로</button>
        )}
      </h2>
      <div className="chart pie-chart">
        <Pie
          data={{
            labels,
            datasets: [
              {
                data: values,
                backgroundColor: labels.map((_, i) => colors[i % colors.length]),
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { display: true },
              title: { display: false },
              tooltip: {
                callbacks: {
                  label: function(context) {
                    const value = context.parsed;
                    return `${context.label}: ${value.toLocaleString()}원`;
                  }
                }
              }
            },
            onClick: handlePieClick,
          }}
          height={300}
        />
      </div>
    </div>
  );
};

export default C3DrilldownPieChart; 